import { render, staticRenderFns } from "./ViewTextForm.vue?vue&type=template&id=21b80052&scoped=true&"
import script from "./ViewTextForm.vue?vue&type=script&lang=js&"
export * from "./ViewTextForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b80052",
  null
  
)

export default component.exports